<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span class="text-h5">Motivo de uso de coche propio</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  label="Tienes coche de empresa, indica el motivo de usar tu coche propio."
                  v-model="reason"
                  :rules="reasonRules"
                  required
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="onCancel">
          {{ $t("cancel") }}
        </v-btn>
        <v-btn color="blue darken-1" text @click="onOk">
          {{ $t("ok") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { logError } from "@/utils";
import ApiService from "@/services/apiService";

export default {
  name: "DialogCompanyCarReason",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: false,
      reason: "",
      reasonRules: [v => !!v || "El motivo es obligatorio."]
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    onCancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    async onOk() {
      if (this.$refs.form.validate()) {
        this.$emit("ok", this.reason);

        let response;
        try{
          response = await ApiService.post(
          "worksession/add-comment",
          { comment: this.reason }
        );
        }catch(error) {
          console.error("Something went wrong: ", error);
          logError("Something went wrong");
        }
        this.dialog = false;
      }
    },
    show() {
      this.reason = "";
      this.dialog = true;
    }
  }
};
</script>